/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, name: "A", value: { checked: false, price: 0, vat: 0 } },
  { id: 1, name: "B", value: { checked: false, price: 0, vat: 0 } },
  { id: 2, name: "C", value: { checked: false, price: 0, vat: 0 } },
  { id: 3, name: "I", value: { checked: false, price: 0, vat: 0 } },
  { id: 4, name: "I1", value: { checked: false, price: 0, vat: 0 } },
  { id: 5, name: "I1a", value: { checked: false, price: 0, vat: 0 } },
  { id: 6, name: "I2", value: { checked: false, price: 0, vat: 0 } },
  { id: 7, name: "II", value: { checked: false, price: 0, vat: 0 } },
  { id: 8, name: "II1", value: { checked: false, price: 0, vat: 0 } },
  { id: 9, name: "II2", value: { checked: false, price: 0, vat: 0 } },
  { id: 10, name: "II2a", value: { checked: false, price: 0, vat: 0 } },
  { id: 11, name: "II2b", value: { checked: false, price: 0, vat: 0 } },
  { id: 12, name: "II2c", value: { checked: false, price: 0, vat: 0 } },
  { id: 13, name: "II2d", value: { checked: false, price: 0, vat: 0 } },
  { id: 14, name: "II3", value: { checked: false, price: 0, vat: 0 } },
  { id: 15, name: "III", value: { checked: false, price: 0, vat: 0 } },
  { id: 16, name: "IV", value: { checked: false, price: 0, vat: 0 } },
  { id: 17, name: "IV1", value: { checked: false, price: 0, vat: 0 } },
  { id: 18, name: "IV2", value: { checked: false, price: 0, vat: 0 } },
  { id: 19, name: "V", value: { checked: false, price: 0, vat: 0 } },
  { id: 20, name: "VI", value: { checked: false, price: 0, vat: 0 } },
  { id: 21, name: "VI1", value: { checked: false, price: 0, vat: 0 } },
  { id: 22, name: "VI2", value: { checked: false, price: 0, vat: 0 } },
  { id: 23, name: "VI3", value: { checked: false, price: 0, vat: 0 } },
  { id: 24, name: "VI4", value: { checked: false, price: 0, vat: 0 } },
  { id: 25, name: "VI41", value: { checked: false, price: 0, vat: 0 } },
  { id: 26, name: "VI42", value: { checked: false, price: 0, vat: 0 } },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Chi tiêu
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Giá trị hàng hóa, dịch vụ (chưa có thuế GTGT)
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Thuế giá trị gia tăng
              </Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"A"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Không phát sinh hoạt động mua, bán trong kỳ (đánh dấu 'X')"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[21]"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              >
                {/* chưa xử lý  */}
                <SwitchField
                  id={0}
                  name="checked"
                  label={""}
                  style={{ fontSize: 14 }}
                  value={data[0].value.checked}
                />
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              >
                {""}
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"B"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng còn được khấu trừ kỳ trước chuyển sang"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[22]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={1} name="vat" value={data[1].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"C"}
              </Td>
              <Td
                colSpan={6}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Kê khai thuế giá trị gia tăng phải nộp ngân sách nhà nước"}
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"I"}
              </Td>
              <Td
                colSpan={6}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Hàng hóa dịch vụ mua vào trong kỳ"}
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              >
                {"Giá trị và thuế giá trị gia tăng của hàng hóa, dịch vụ mua vào"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[23]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={4}
                  name="price"
                  value={data[4].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[24]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={4} name="vat" value={data[4].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {""}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              >
                {"Trong đó: hàng hóa, dịch vụ nhập khẩu"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[23a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={5}
                  name="price"
                  value={data[5].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[24a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={5} name="vat" value={data[5].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              >
                {"Thuế giá trị gia tăng của hàng hóa, dịch vụ mua vào được khấu trừ kỳ này"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[25]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={6} name="vat" value={data[6].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"II"}
              </Td>
              <Td
                colSpan={6}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Hàng hóa dịch vụ bán ra trong kỳ"}
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Hàng hóa, dịch vụ bán ra không chịu thuế giá trị gia tăng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[26]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={8}
                  name="price"
                  value={data[8].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                }}
              ></Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {
                  "Hàng hóa, dịch vụ bán ra chịu thuế giá trị gia tăng ([27]=[29]+[30]+[32]+[32a];[28]=[31]+[33]"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"[27]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={9}
                  name="price"
                  readonly="true"
                  value={data[9].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"[28]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={9}
                  name="vat"
                  readonly="true"
                  value={data[9].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={10}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"a"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hàng hóa, dịch vụ bán ra chịu thuế suất 0%"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[29]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={10}
                  name="price"
                  value={data[10].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {""}
              </Td>
            </tr>
            <tr key={11}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"b"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hàng hóa, dịch vụ bán ra chịu thuế suất 5%"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[30]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={11}
                  name="price"
                  value={data[11].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[31]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={11} name="vat" value={data[11].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={12}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"c"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hàng hóa, dịch vụ bán ra chịu thuế suất 10%"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[32]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={12}
                  name="price"
                  value={data[12].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[33]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={12} name="vat" value={data[12].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={13}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"d"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hàng hóa, dịch vụ bán ra không tính thuế"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[32a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={13}
                  name="price"
                  value={data[13].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {""}
              </Td>
            </tr>
            <tr key={14}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {
                  "Tổng doanh thu và thuế giá trị gia tăng của hàng hóa, dịch vụ bán ra ([34]=[26]+[27];[35]=[28]"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[34]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={14}
                  name="price"
                  readonly="true"
                  value={data[14].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[35]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={14}
                  name="vat"
                  readonly="true"
                  value={data[14].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={15}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"III"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng phát sinh trong kỳ ([36]=[35]-[25])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[36]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={15}
                  name="vat"
                  readonly="true"
                  value={data[15].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={16}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"IV"}
              </Td>
              <Td
                colSpan={6}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Điều chỉnh tăng, giảm thuế giá trị gia tăng còn được khấu trừ của các kỳ trước"}
              </Td>
            </tr>
            <tr key={17}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh giảm"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[37]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={17} name="vat" value={data[17].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={18}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh tăng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[38]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={18} name="vat" value={data[18].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={19}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"V"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Thuế giá trị gia tăng nhận bàn giao được khấu trừ trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[39]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={19} name="vat" value={data[19].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={20}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"VI"}
              </Td>
              <Td
                colSpan={6}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Xác định nghĩa vụ thuế giá trị gia tăng phải nộp trong kỳ"}
              </Td>
            </tr>
            <tr key={21}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Thuế giá trị gia tăng phải nộp của hoạt động sản xuất kinh doanh trong kỳ {[40a]=([36]-[22]+[37]-[38]-[39a]) >= 0}"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[40a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={21}
                  name="vat"
                  readonly="true"
                  value={data[21].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={22}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {
                  "Thuế giá trị gia tăng mua vào của dự án đầu tư được bù trừ với thuế GTGT còn phải nộp của hoạt động sản xuất kinh doanh cùng kỳ tính thuế ([40b]<=[41])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[40b]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={22} name="vat" value={data[22].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={23}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế giá trị gia tăng còn phải nộp trong kỳ ([40]=[40a]-[40b])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[40]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={23}
                  name="vat"
                  readonly="true"
                  value={data[23].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={24}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {
                  "Thuế giá trị gia tăng chưa khấu trừ hết kỳ này {[41]=([36]-[22]+[37]-[38]-[39a]) <= 0}"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"[41]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={24}
                  name="vat"
                  readonly="true"
                  value={data[24].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={25}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"4.1"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế giá trị gia tăng đề nghị hoàn ([42] <= [41])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"[42]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable id={25} name="vat" value={data[25].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={26}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"4.1"}
              </Td>
              <Td
                colSpan={4}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế giá trị gia tăng còn được khấu trừ chuyển kỳ sau ([43]=[41]-[42])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"[43]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={26}
                  name="vat"
                  readonly="true"
                  value={data[26].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
